import { render, staticRenderFns } from "./GerenciarTransacoesEmpenhoSIAF.vue?vue&type=template&id=354efe92&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./GerenciarTransacoesEmpenhoSIAF.vue?vue&type=style&index=0&id=354efe92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354efe92",
  null
  
)

export default component.exports